module.exports = __webpack_public_path__ + "static/img/cr_header_jjhj.36dfb031.png";